import React, { useEffect } from "react";
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from "react-router-dom";
import { logUI } from "../../api/andyliticsApi";

const MembershipNotificationModal = (props) => {
    let parsedMessage = props.autoLinkNotifications.message || '';
    let linkIndex = props.autoLinkNotifications.message.indexOf("a href='#'");
    parsedMessage = parsedMessage.replace(`<a href='#'>linked accounts</a>.`, '')
    parsedMessage = parsedMessage.replace(`<a href='tel:`, `<a class='phone-link' href='tel:`)

    useEffect(() => {
        logUI("MBHWeb.Dashboard.MembershipNotificationModal.Rendered", null, null, props.autoLinkNotifications);
    }, [])


    return (
        <Modal className="autolink-message-modal" isOpen={true} centered backdrop="static" keyboard={false}>
            <ModalBody>
                {/*this static html is static text generated in memberships api. it never is user generated content */}
                <span dangerouslySetInnerHTML={{ __html: parsedMessage }}></span>
                {linkIndex > -1 && <span><Link to={{ pathname: "/linkedaccounts" }} onClick={() => props.onNotificationResponse("linked accts clicked", props.autoLinkNotifications.id)}>linked accounts</Link>.</span>}

            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn text-btn" onClick={() => props.onNotificationResponse(props.autoLinkNotifications.responseOne, props.autoLinkNotifications.id)}>
                {props.autoLinkNotifications.responseOne.toUpperCase()}</button>
            </ModalFooter>
        </Modal>
    );

}

export default MembershipNotificationModal;